<template>
  <div class="config-bot-add animated fadeIn">
    <Forms ref="frmDefault"
      :title="'CONFIGURAÇÃO BOT - HORÁRIO E MENSAGEM FORA DO HORÁRIO'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      :disabledKeyUpEnter="true"
      :isModal="isModal"
      v-on:Clear="onClear"
      v-on:Back="$emit('Back')"
      v-on:Save="onSave">
      <!-- Card verde: resumo -->
      <div class="status-card">
        <div class="status-grid">
          <div class="status-item">
            <div class="status-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="status-info">
              <h3>Dias Configurados</h3>
              <p>{{ diasConfiguradosTexto }}</p>
            </div>
          </div>
          <div class="status-item">
            <div class="status-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div class="status-info">
              <h3>Dias não configurados</h3>
              <p>{{ diasNaoConfiguradosTexto }}</p>
            </div>
          </div>
          <div class="status-item">
            <div class="status-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div class="status-info">
              <h3>Status do Bot</h3>
              <p>{{ statusBot }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="row">
          <b-form-group label="Provedor" label-for="cmb-provedor" class="col-md-6">
            <b-form-select id="cmb-provedor" v-model="form.provedor.value" :options="provedorOptions" required>
              <template #first>
                <b-form-select-option :value="null" disabled>{{ $lang.Common.PlaceholderSelect }}</b-form-select-option>
              </template>
            </b-form-select>
            <div class="invalid-feedback d-block" v-if="form.provedor.required && !form.provedor.value">
              Selecione um provedor.
            </div>
          </b-form-group>
        </div>
      </div>

      <div class="form-group">
        <label><small v-if="form.mensagemForaHorario.required" class="text-danger">*</small> Mensagem fora do horário</label>
        <b-form-textarea
          rows="4"
          v-model="form.mensagemForaHorario.value"
          placeholder="Mensagem enviada quando o usuário acionar o bot fora do horário de atendimento."
          :state="form.mensagemForaHorario.state"
          class="form-textarea-custom"
        />
      </div>

      <div class="schedule-section">
        <div class="schedule-header">
          <h2 class="schedule-title">Horários da Semana</h2>
          <button type="button" class="btn-remove-all" @click="clearAllSlots" :disabled="totalPeriodos === 0">
            <svg width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            Remover todos os horários
          </button>
        </div>

        <div
          v-for="(dia, idx) in horariosPorDia"
          :key="dia.diaSemana"
          class="day-card"
          :class="{ active: dia.slots.length > 0, expanded: expandedDays[idx] }"
        >
          <div class="day-header" @click="toggleDay(idx)">
            <div class="day-info">
              <span class="day-name">{{ dia.diaSemana }}</span>
              <span class="day-status">
                <span class="status-dot"></span>
                {{ dayStatusText(dia) }}
              </span>
            </div>
            <div class="day-actions">
              <svg class="expand-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
          <transition name="day-body">
            <div v-if="expandedDays[idx]" class="day-body">
              <div v-if="dia.slots.length > 0" class="time-slots">
                <div v-for="(slot, sIdx) in dia.slots" :key="sIdx" class="time-slot" :class="{ 'has-error': getSlotError(idx, sIdx) }">
                  <div class="time-input-group">
                    <label>Hora inicial</label>
                    <b-form-input type="time" v-model="slot.horaInicial" @click.native.stop @input="clearSlotErrorsForDay(idx)" />
                  </div>
                  <div class="time-input-group">
                    <label>Hora final</label>
                    <b-form-input type="time" v-model="slot.horaFinal" @click.native.stop @input="clearSlotErrorsForDay(idx)" />
                  </div>
                  <button type="button" class="btn-icon btn-remove" @click.stop="removeSlot(idx, sIdx)" title="Remover">
                    <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                  <div v-if="getSlotError(idx, sIdx)" class="slot-error text-danger small">
                    {{ getSlotError(idx, sIdx) }}
                  </div>
                </div>
              </div>
              <div v-else class="empty-state">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <p>Nenhum horário configurado. Adicione um período para ativar o atendimento neste dia.</p>
              </div>
              <button type="button" class="btn-add-slot" @click.stop="addSlot(idx)">
                <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                Adicionar período
              </button>
            </div>
          </transition>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ConfiguracaoBotRepository from '@/shared/http/repositories/configurations/configuracaoBot.js'
import ConfiguracaoBotModel from '@/shared/models/configurations/configuracaoBotmodel.js'
import NumRepository from '@/shared/http/repositories/access/cadastroNum.js'

const DAYS_OF_WEEK = [
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado',
  'Domingo'
]

const DAYS_ABREV = {
  'Segunda-feira': 'Seg',
  'Terça-feira': 'Ter',
  'Quarta-feira': 'Qua',
  'Quinta-feira': 'Qui',
  'Sexta-feira': 'Sex',
  'Sábado': 'Sáb',
  'Domingo': 'Dom'
}

function buildHorariosPorDia () {
  return DAYS_OF_WEEK.map(diaSemana => ({ diaSemana, slots: [] }))
}

function parseTimeToMinutes (hora) {
  if (!hora || typeof hora !== 'string') return 0
  const part = hora.trim().substring(0, 5)
  const [h, m] = part.split(':').map(x => parseInt(x, 10) || 0)
  return h * 60 + m
}

function rangesOverlap (a1, a2, b1, b2) {
  const sa = parseTimeToMinutes(a1)
  const ea = parseTimeToMinutes(a2)
  const sb = parseTimeToMinutes(b1)
  const eb = parseTimeToMinutes(b2)
  return sa < eb && sb < ea
}

export default {
  name: 'ConfiguracaoBotAdd',
  mixins: [ActionsForm],
  props: {
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: { ...ConfiguracaoBotModel },
      form: {
        mensagemForaHorario: { value: '', required: false, state: null },
        provedor: { value: null, required: true, state: null }
      },
      provedorOptions: [],
      horariosPorDia: buildHorariosPorDia(),
      expandedDays: {},
      slotErrors: {}
    }
  },
  computed: {
    diasConfiguradosTexto () {
      const dias = this.horariosPorDia.filter(d => d.slots.length > 0).map(d => DAYS_ABREV[d.diaSemana] || d.diaSemana)
      return dias.length ? dias.join(', ') : 'Nenhum'
    },
    diasNaoConfiguradosTexto () {
      const dias = this.horariosPorDia.filter(d => d.slots.length === 0).map(d => DAYS_ABREV[d.diaSemana] || d.diaSemana)
      return dias.length ? dias.join(', ') : 'Nenhum'
    },
    totalPeriodos () {
      return this.horariosPorDia.reduce((acc, d) => acc + d.slots.length, 0)
    },
    statusBot () {
      return this.totalPeriodos > 0 ? 'Ativo' : 'Inativo'
    }
  },
  methods: {
    clearAllSlots () {
      this.horariosPorDia.forEach(dia => { dia.slots = [] })
      this.slotErrors = {}
    },
    dayStatusText (dia) {
      if (!dia.slots || dia.slots.length === 0) return 'Sem horário'
      if (dia.slots.length === 1) {
        const s = dia.slots[0]
        const ini = (s.horaInicial || '').substring(0, 5)
        const fim = (s.horaFinal || '').substring(0, 5)
        if (ini === '00:00' && fim === '23:59') return '24 horas'
      }
      return dia.slots.length === 1 ? '1 período ativo' : dia.slots.length + ' períodos ativos'
    },
    getSlotError (diaIdx, slotIdx) {
      return this.slotErrors[`${diaIdx}-${slotIdx}`] || null
    },
    clearSlotErrorsForDay (diaIdx) {
      const keys = Object.keys(this.slotErrors).filter(k => k.startsWith(`${diaIdx}-`))
      keys.forEach(k => this.$delete(this.slotErrors, k))
    },
    validateAllSlots () {
      this.slotErrors = {}
      let valid = true
      this.horariosPorDia.forEach((dia, diaIdx) => {
        const slots = dia.slots
        slots.forEach((slot, slotIdx) => {
          const key = `${diaIdx}-${slotIdx}`
          const ini = slot.horaInicial || ''
          const fim = slot.horaFinal || ''

          if (!ini.trim() || !fim.trim()) {
            this.$set(this.slotErrors, key, 'Informe a hora inicial e a hora final.')
            valid = false
            return
          }

          const minIni = parseTimeToMinutes(ini)
          const minFim = parseTimeToMinutes(fim)
          if (minIni >= minFim) {
            this.$set(this.slotErrors, key, 'A hora inicial deve ser anterior à hora final.')
            valid = false
            return
          }

          for (let other = 0; other < slots.length; other++) {
            if (other === slotIdx) continue
            const o = slots[other]
            if (rangesOverlap(ini, fim, o.horaInicial || '', o.horaFinal || '')) {
              this.$set(this.slotErrors, key, 'Este período sobrepõe outro período configurado neste dia.')
              valid = false
              return
            }
          }
        })
      })

      if (!valid && Object.keys(this.slotErrors).length > 0) {
        const firstKey = Object.keys(this.slotErrors)[0]
        const diaIdx = parseInt(firstKey.split('-')[0], 10)
        this.$set(this.expandedDays, diaIdx, true)
      }
      return valid
    },
    toggleDay (idx) {
      this.$set(this.expandedDays, idx, !this.expandedDays[idx])
    },
    onLoad () {
      this.loadProvedores()
    },
    async loadProvedores () {
      try {
        const requestConfig = { params: { active: 1 } }
        const response = await NumRepository.getEnvAll(requestConfig)
        const content = (response.data && response.data.content) ? response.data.content : (Array.isArray(response.data) ? response.data : [])
        this.provedorOptions = content.map(x => ({
          value: x.id,
          text: x.name || x.number || `Provedor ${x.id}`
        }))
      } catch (error) {
        console.error('Erro ao carregar provedores:', error)
      }
    },
    addSlot (diaIdx) {
      this.horariosPorDia[diaIdx].slots.push({ horaInicial: '09:00', horaFinal: '17:00' })
    },
    removeSlot (diaIdx, slotIdx) {
      this.horariosPorDia[diaIdx].slots.splice(slotIdx, 1)
    },
    onClear () {
      this.form.mensagemForaHorario.value = ''
      this.form.provedor.value = null
      this.data.id = null
      this.data.mensagemForaHorario = ''
      this.data.idProvedor = null
      this.data.horarios = []
      this.horariosPorDia = buildHorariosPorDia()
      this.expandedDays = {}
      this.slotErrors = {}
    },
    onAdd () {
      Tools.ClearDataForms(this.form, this.data)
      this.form.provedor.value = null
      this.provedorOptions = []
      this.horariosPorDia = buildHorariosPorDia()
      this.expandedDays = {}
      this.slotErrors = {}
      this.loadProvedores()
    },
    onEdit (obj) {
      if (!obj) return
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      this.data.id = obj.id
      this.data.mensagemForaHorario = obj.mensagemForaHorario
      this.data.idProvedor = obj.provedor ? obj.provedor.id : null
      this.form.provedor.value = this.data.idProvedor
      this.form.mensagemForaHorario.value = obj.mensagemForaHorario || ''
      if (obj.provedor) {
        this.provedorOptions = [{ value: obj.provedor.id, text: obj.provedor.name || obj.provedor.number || `Provedor ${obj.provedor.id}` }]
      }
      this.horariosPorDia = buildHorariosPorDia()
      if (obj.horarios && obj.horarios.length) {
        obj.horarios.forEach(h => {
          const dia = this.horariosPorDia.find(d => d.diaSemana === h.diaSemana)
          if (dia) {
            dia.slots.push({
              horaInicial: h.horaInicial ? (typeof h.horaInicial === 'string' ? h.horaInicial.substring(0, 5) : '09:00') : '09:00',
              horaFinal: h.horaFinal ? (typeof h.horaFinal === 'string' ? h.horaFinal.substring(0, 5) : '17:00') : '17:00'
            })
          }
        })
      }
      this.expandedDays = {}
      loading.pop()
    },
    buildHorariosPayload () {
      const horarios = []
      this.horariosPorDia.forEach(dia => {
        dia.slots.forEach(slot => {
          horarios.push({
            id: 0,
            diaSemana: dia.diaSemana,
            horaInicial: slot.horaInicial || '09:00',
            horaFinal: slot.horaFinal || '17:00'
          })
        })
      })
      return horarios
    },
    onCreate () {
      if (!this.form.provedor.value) {
        toast.warning('Selecione um provedor.')
        return
      }
      loading.push()
      this.data.idProvedor = parseInt(this.form.provedor.value)
      this.data.mensagemForaHorario = this.form.mensagemForaHorario.value || ''
      this.data.horarios = this.buildHorariosPayload()

      ConfiguracaoBotRepository.Create(this.data)
        .then(() => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      if (!this.form.provedor.value) {
        toast.warning('Selecione um provedor.')
        return
      }
      if (!this.validateAllSlots()) {
        toast.warning('Corrija os erros nos horários antes de salvar.')
        return
      }
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.idProvedor = parseInt(this.form.provedor.value)
      this.data.mensagemForaHorario = this.form.mensagemForaHorario.value || ''
      this.data.horarios = this.buildHorariosPayload()

      ConfiguracaoBotRepository.Update(this.data)
        .then(() => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>

<style lang="scss" scoped>
$success: #10b981;
$success-light: #d1fae5;
$primary: #2563eb;
$primary-light: #dbeafe;
$neutral-50: #fafafa;
$neutral-100: #f5f5f5;
$neutral-200: #e5e5e5;
$neutral-300: #d4d4d4;
$neutral-500: #737373;
$neutral-600: #525252;
$neutral-700: #404040;
$neutral-800: #262626;
$danger: #ef4444;
$danger-light: #fee2e2;
$radius-md: 10px;
$radius-lg: 16px;
$shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);

.config-bot-add {
  .form-textarea-custom {
    border-radius: $radius-md;
    border: 2px solid $neutral-200;
    background: $neutral-50;
    transition: border-color 0.2s, box-shadow 0.2s;
    &:focus {
      border-color: $primary;
      background: #fff;
      box-shadow: 0 0 0 3px $primary-light;
    }
  }
}

.status-card {
  background: linear-gradient(135deg, $success 0%, #059669 100%);
  color: white;
  padding: 1.25rem 1.5rem;
  border-radius: $radius-lg;
  box-shadow: $shadow-lg;
  margin-bottom: 1.5rem;
}

.status-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1.25rem;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.status-icon {
  width: 44px;
  height: 44px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: $radius-md;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  svg {
    width: 22px;
    height: 22px;
  }
}

.status-info h3 {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.9;
  margin: 0 0 0.2rem 0;
}

.status-info p {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
}

.schedule-section {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 2px solid $neutral-100;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.schedule-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: $neutral-800;
  margin: 0;
}

.btn-remove-all {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: $danger;
  background: $danger-light;
  border: 1px solid rgba($danger, 0.3);
  border-radius: $radius-md;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  &:hover:not(:disabled) {
    background: $danger;
    color: white;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.day-card {
  position: relative;
  border: 2px solid $neutral-200;
  border-radius: $radius-md;
  margin-bottom: 1rem;
  overflow: hidden;
  transition: border-color 0.3s, box-shadow 0.3s;

  &.active {
    border-color: $success;
    box-shadow: 0 0 0 3px $success-light;
  }
}

.day-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.9rem 1.25rem;
  background: $neutral-50;
  cursor: pointer;
  transition: background 0.2s;
  user-select: none;

  .day-card.active & {
    background: $success-light;
  }
  &:hover {
    background: $neutral-100;
  }
  .day-card.active &:hover {
    background: #a7f3d0;
  }
}

.day-info {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.day-name {
  font-weight: 700;
  font-size: 1rem;
  color: $neutral-800;
  min-width: 120px;
}

.day-status {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  background: white;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  .day-card.active & {
    color: $success;
  }
  .day-card:not(.active) & {
    color: $neutral-500;
  }
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
}

.day-actions .expand-icon {
  width: 20px;
  height: 20px;
  color: $neutral-500;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.day-card.expanded .expand-icon {
  transform: rotate(180deg);
}

.day-body {
  padding: 1.25rem;
  background: white;
  border-top: 1px solid $neutral-200;
}

.day-body-enter-active,
.day-body-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.day-body-enter,
.day-body-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.time-slots {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.time-slot {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 1rem;
  align-items: end;
  &.has-error {
    padding-bottom: 0.25rem;
  }
}

.slot-error {
  grid-column: 1 / -1;
  margin-top: 0.25rem;
  margin-bottom: 0;
}

.time-input-group {
  label {
    font-size: 0.85rem;
    font-weight: 600;
    color: $neutral-600;
    margin-bottom: 0.4rem;
    display: block;
  }
  .form-control {
    border-radius: $radius-md;
    border: 2px solid $neutral-200;
    padding: 0.6rem 0.75rem;
    transition: border-color 0.2s, box-shadow 0.2s;
    &:focus {
      border-color: $primary;
      box-shadow: 0 0 0 3px $primary-light;
    }
  }
}

.btn-icon {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: $radius-md;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s, transform 0.2s;
}

.btn-remove {
  background: $danger-light;
  color: $danger;
  &:hover {
    background: $danger;
    color: white;
    transform: scale(1.05);
  }
}

.btn-add-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: $primary-light;
  border: 2px dashed $primary;
  border-radius: $radius-md;
  font-weight: 600;
  color: #1e40af;
  cursor: pointer;
  width: 100%;
  margin-top: 0.75rem;
  transition: all 0.2s;
  &:hover {
    background: $primary;
    color: white;
    border-style: solid;
  }
  svg {
    flex-shrink: 0;
  }
}

.empty-state {
  text-align: center;
  padding: 1.5rem 1rem;
  color: $neutral-500;
  margin-bottom: 0.75rem;
  svg {
    width: 48px;
    height: 48px;
    margin-bottom: 1rem;
    opacity: 0.5;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  p {
    margin: 0;
    font-size: 0.95rem;
  }
}

@media (max-width: 768px) {
  .status-grid {
    grid-template-columns: 1fr;
  }
  .time-slot {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/configuracaoBot/components/add/configuracaoBotadd.vue